import { render, staticRenderFns } from "./MyHistory.vue?vue&type=template&id=59ecc1f6&scoped=true&"
import script from "./MyHistory.vue?vue&type=script&lang=js&"
export * from "./MyHistory.vue?vue&type=script&lang=js&"
import style0 from "./MyHistory.vue?vue&type=style&index=0&id=59ecc1f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ecc1f6",
  null
  
)

export default component.exports